/**
 * Given a statementId, return the PRORegionFilter. ASCAP international statements contain the code
 * 'AI' in the 11th and 12th characters. All other statements are treated as domestic.
 *
 * Examples:
 * getRegionFilterFromStatementId(1617120672AS0311628420194P) // returns 'standard'
 * getRegionFilterFromStatementId(1617120673AI0311628420202U) // returns 'international'
 * @param statementId
 * @returns
 */
export const getRegionFilterFromStatementId = (
    statementId: string,
): PRORegionFilter => {
    if (statementId.slice(10, 12) === 'AI') {
        return 'international';
    }

    return 'standard';
};
